import React, { useEffect, useState } from "react";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import { Button, Container, Modal } from "react-bootstrap";
import LeftArrow from "../../../../assets/images/icons/back.png";
import { useNavigate } from "react-router-dom";
import Footer from "../../../../containers/Footer";
import { getDepositRequest } from "../../../../redux/user/actions";
import moment from "moment";
import PaginationCard from "../../../components/PaginationCard";
import usePaginationHook from "../../../../hooks/usePaginationHook";
import { QueryStringfy } from "../../../../utils/qs.utils";

const DepositListPage = () => {
  const navigate = useNavigate();
  const [depositList, setDepositList] = useState({
    count: 0,
    pagesize: 15,
    Deposits: [],
  });
  console.log(depositList);
  const [modalConfig, setModalConfig] = useState({
    show: false,
    imageUrl: null,
  });
  const pagination = usePaginationHook({});

  useEffect(() => {
    const queryString = QueryStringfy({ ...pagination?.apiParams });
    getList(queryString);
  }, [pagination?.apiParams?.pagesize, pagination?.apiParams?.skip]);

  // Get deposit data from api
  const getList = async (query) => {
    const response = await getDepositRequest(query);
    if (response && response?.data?.data?.data) {
      setDepositList(response?.data?.data?.data);
    }
  };

  return (
    <>
      <HeaderAfterLogin />

      <main className="main">
        <Container>
          <div className="headingSec">
            <div className="back-link" onClick={() => navigate(-1)}>
              <img src={LeftArrow} alt="LeftArrow" /> <h1>Deposit List</h1>
            </div>
          </div>

          <div className="container table-responsive mt-4">
            <table className="table text-white">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Amount</th>
                  <th scope="col">utrNo</th>
                  <th scope="col">Comment</th>
                  <th scope="col">mode</th>
                  <th scope="col">status</th>
                  <th scope="col">Created At</th>
                  <th scope="col">Transaction Image</th>
                </tr>
              </thead>
              <tbody>
                {depositList?.Deposits?.map((item, index) => {
                  return (
                    <tr>
                      <th scope="row">
                        {index + pagination.apiParams.skip + 1}
                      </th>

                      <td>{item?.amount}</td>
                      <td>{item?.utrNo}</td>
                      <td>{item?.comment}</td>
                      <td>{item?.mode}</td>
                      <td>{item?.status}</td>
                      <td>{moment(item?.createdAt).format("DD-MM-YY h:mm")}</td>

                      <td
                        onClick={() =>
                          setModalConfig({
                            show: true,
                            imageUrl: item?.txnImage,
                          })
                        }
                        style={{ color: "#228be6", cursor: "pointer" }}
                      >
                        {`${item?.txnImage?.slice(0, 20)}${
                          item?.txnImage?.length > 21 ? "...." : ""
                        }` || null}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className=" border-t px-3 pb-5">
            <PaginationCard
              pagination={pagination}
              count={depositList?.count}
            />
          </div>
          <Modal
            show={modalConfig?.show}
            onHide={() => setModalConfig({ show: false, imageUrl: null })}
            centered
          >
            <Modal.Header></Modal.Header>
            <Modal.Body>
              <div>
                <img
                  src={modalConfig?.imageUrl}
                  style={{ width: "50%", margin: "0 auto" }}
                />
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => setModalConfig({ show: false, imageUrl: null })}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </Container>
      </main>
      <Footer />
    </>
  );
};

export default DepositListPage;
